"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicInterceptor = void 0;
const axios_1 = require("axios");
class BasicInterceptor {
    onRequest(config) {
        if (!config.headers) {
            config.headers = new axios_1.AxiosHeaders();
        }
        if (!config.params) {
            config.params = {};
        }
        config.allowAbsoluteUrls = false;
        return config;
    }
}
exports.BasicInterceptor = BasicInterceptor;
